export default __webpack_public_path__ + "assets/b6926f142c3f67f7db61b4334637496b.svg";